import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden';

export default class HorizontalCard extends React.Component{
    static defaultProps = {
	imagePadding: 0,
    };
    
    render(){
	let payload;
	if(this.props.image){
	    payload = <Hidden xsDown>
		<div style={{flex: 1,
			     maxWidth: '10rem',
			     display: 'flex',
			     alignSelf: 'center',
		}}>
		    <img style={{width: 'calc(100% - ' + this.props.imagePadding + 'px)', height: '100%', margin: 'auto'}}
			 src={this.props.image} />
		</div>
	    </Hidden>;
	}else{

	}
	return (
	    <Card className="card white"
		  elevation={2}
		  style={{
		      display: 'flex',
		      alignItems: 'stretch',
		      height: '100%',
		  }}>
		{payload}
		<CardContent style={{flex: 2,
				     alignSelf: 'stretch'
		}}>
		    <Typography variant="headline" className="title">
			{this.props.title}
		    </Typography>
		    {this.props.children}
		</CardContent>
	    </Card>
	);
    }
}



// WEBPACK FOOTER //
// ./src/components/horizontal-card.jsx